(function ($) {
  $(document).ready(function () {
    // const sPageURL = window.location.search.substring(1);
    const pathParam = decodeURIComponent(window.location.search.substring(1));

    let latestBlogItem = $(
      ".pageBlog__viewWrapper .overviewBlogItem--page:nth-of-type(4)"
    );

    if (pathParam == "" || pathParam == "page=0") {
      latestBlogItem.remove();
    }

  });
})(jQuery);
